import * as React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';

import { useApplication } from '../AppContext';

function getBackgroundStyle(game) {
	const { name, image } = game;
	return {
		backgroundImage: `url('../assets/MoreGames/${name}.png'), url(${image})`,
	};
}

const MoreGames = () => {
	const app = useApplication();
	const { t } = useTranslation();

	const marketPlace = app.marketPlace;

	React.useEffect(() => {
		app.achievements.awardAchivement(app.userdata, 'See More Games');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const showGame = React.useCallback((name) => {
		marketPlace.show(name);
	}, [marketPlace]);

	const listItems = React.useMemo(() => {
		const games = marketPlace.getGames();
		return games.map((game) =>
			<li
				key={game.name}
				className={classnames('button')}
				onClick={() => showGame(game.name)}
				style={getBackgroundStyle(game)}
			>
				{game.name}
			</li>,
		);
	}, [marketPlace, showGame]);

	return (
		<div id="MoreGames" className="page1">
			<div className="wrapper">
				<PageTitle>
					<h1 className="title">{t('More Games')}</h1>
				</PageTitle>
				<div className="content-narrow">
					<ul className="buttonList">
						{listItems}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default React.memo(MoreGames);
